import { ButtonConfig } from '@api/types';
import { Button, ContentArea, ExpandableSubmenu, MdIcon } from '@components';
import { Container, styled } from '@mui/material';
import { spacing } from '@themes/theme.helpers';

export type SubmenuBlockProps = {
  buttonLabel: string;
  children?: React.ReactNode;
  content?: any;
  buttonConfig?: ButtonConfig;
};

export const SubmenuBlock = ({ buttonConfig = {}, content = [] }: SubmenuBlockProps) => {
  const { color, label, variant, startIcon, endIcon } = buttonConfig;
  const startIconComponent = startIcon ? <MdIcon iconName={startIcon} /> : null;
  const endIconComponent = endIcon ? <MdIcon iconName={endIcon} /> : null;
  const header = (
    <Button
      color={color}
      variant={variant}
      startIcon={startIconComponent}
      endIcon={endIconComponent}
    >
      {label}
    </Button>
  );
  const main = (
    <StyledContainer>
      <ContentArea content={content} />
    </StyledContainer>
  );
  return <ExpandableSubmenu header={header} content={main}></ExpandableSubmenu>;
};

const StyledContainer = styled(Container)`
  padding-bottom: ${spacing(4)};
`;
